import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class CardCompanySwiper {
  constructor() {
    this._init();
  }

  private _init() {
    const swiperElements = document.querySelectorAll('.card-company__swiper');
    if (swiperElements) {
      swiperElements.forEach(swiperElement => {
        new Swiper(swiperElement as HTMLElement, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',

          fadeEffect: {
            crossFade: true,
          },
          allowTouchMove: true,

          // Configuration de la pagination
          pagination: {
            el: '.card-company__pagination',
            clickable: true,
            bulletActiveClass: 'swiper-pagination-bullet-active',
            bulletClass: 'swiper-pagination-bullet',
          },

          // Ajout du module de pagination
          modules: [Pagination],
        });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CardCompanySwiper();
});
